module.exports = __webpack_public_path__ + "img/logo-header.f00b222e.png";